
export default {
    spacingDebug: true,
    components: {
        HeaderTemplate: () => import("~/components/global/templates/HeaderTemplate"),
        CardDeckTemplate: () => import("~/components/global/templates/CardDeckTemplate"),
        ButtonTemplate: () => import("~/components/global/templates/ButtonTemplate"),
    },
    props: {
        sectionId: { type: String, default: "news-items" },
        payload: { type: Object, default: () => ({}) },
    },
    data() {
        return {
            // Seed a single random 4-digit string per component instance to prevent mismatch/re-evaluations
            randomSeed: null,
        };
    },
    computed: {
        heading() {
            const heading = this.payload?.heading || {};
            return {
                textContent: heading.textContent || "Latest in the News",
                level: heading.level || "h2",
                alignment: heading.alignment || "center",
            };
        },
        items() {
            const items = this.payload?.body?.items;
            return Array.isArray(items) ? items.filter((item) => item?.slug && item?.title) : [];
        },
    },
    mounted() {
        this.randomSeed = this.getRandom4DigitString();
    },
    methods: {
        getImageId(index) {
            const seed = this.randomSeed || "0000";
            return `447e0415-0243-4344-8d31-5998fa08f265-${seed}-${index}`;
        },
        image(item) {
            const images = Array.isArray(item.images) ? item.images : [];
            const image = images.find((image) => image?.category === "image" && image?.path) || images.find((image) => image?.path);
            return {
                src: image?.path || "/assets/defaults/mico-thumbnail-[light].webp",
                alt: image?.alt || item.title,
            };
        },
        dateLabel(item) {
            if (!item.published_at) return "";
            const date = this.$moment(item.published_at);
            return date.isValid() ? date.format("MMM D, YYYY") : "";
        },
        isFeatured(item) {
            return [true, 1, "1"].includes(item.is_featured);
        },
        cardSubheader(item) {
            return [this.dateLabel(item), this.isFeatured(item) ? "(Featured)" : ""].filter(Boolean).join(" ");
        },
        getRandom4DigitString() {
            return Math.floor(Math.random() * 10000)
                .toString()
                .padStart(4, "0");
        },
    },
};
